/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Studio_Photo_RemoveInputs */

const en_directory_ai_tools_studio_photo_remove = /** @type {(inputs: Directory_Ai_Tools_Studio_Photo_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove photo`)
};

const zh_directory_ai_tools_studio_photo_remove = /** @type {(inputs: Directory_Ai_Tools_Studio_Photo_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移除照片`)
};

/**
* | output |
* | --- |
* | "Remove photo" |
*
* @param {Directory_Ai_Tools_Studio_Photo_RemoveInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_studio_photo_remove = /** @type {((inputs?: Directory_Ai_Tools_Studio_Photo_RemoveInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Studio_Photo_RemoveInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_studio_photo_remove(inputs)
	return zh_directory_ai_tools_studio_photo_remove(inputs)
});
export { directory_ai_tools_studio_photo_remove as "directory.ai_tools.studio.photo_remove" }